import React, { useEffect, useState } from "react";
import PartnerTable from "./PartnerTable/PartnerTable";
import { useDispatch, useSelector } from "react-redux";
import { findAllPartnerAction } from "../../actions/partnerAction/partnerAction";
import usePrivilegeCheck from "../../constants/customHooks/UsePrivilegeCheck";
import { Alert, AlertTitle, Pagination } from "@mui/material";

// material Table
const columns = [
  {
    title: "Sl no",
    field: "sl",
  },
  {
    title: "Partner Name",
    field: "partnerName",
    hidden: false,
  },
  {
    title: "Email",
    field: "email",
    hidden: false,
  },
  {
    title: "Phone",
    field: "phone",
    hidden: false,
  },
  {
    title: "Manager",
    field: "manager",
    hidden: false,
  },
  {
    title: "",
    field: "action",
    filtering: false,
  },
];

function PartnerKycApproval() {
  const dispatch = useDispatch();

  const [partnerdata, setPartnerData] = useState([]);
  const [page, setPage] = useState(1)
  const [pagiantionEntry, setPagiantionEntry] = useState(25 );

  const { privilege, hasPrivilege } = usePrivilegeCheck();


  let { partnerFindSuccess } = useSelector((state) => {
    return state.findAllPartner;
  });

  useEffect(() => {
    if (partnerFindSuccess) {
      // setPartnerData(
      //   partnerFindSuccess
      //     ?.payload?.filter((data) => data.KYCverification !== true)
      //     .map((item) => ({
      //       id: item.id,
      //       column1: item.name,
      //       column2: item.email,
      //       column3: item.phone,
      //       column4: item.user?.firstName,
      //     }))
      // );
      setPartnerData(partnerFindSuccess?.payload.map((item) => ({
        id: item.id,
        column1: item.name,
        column2: item.email,
        column3: item.phone,
        column4: item.user?.firstName,
      })))
    }
  }, [partnerFindSuccess]);

  useEffect(() => {
    dispatch(findAllPartnerAction(pagiantionEntry, page, "partnerkyc"));
  }, [dispatch, pagiantionEntry, page]);

  const handleChangePage = (event, newPage) => {
    try {
      setPage(newPage)
    } catch(error) {
      console.log(error);
    }
  }


  if (!hasPrivilege("Partner KYC approvel") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  return (
    <>
      <PartnerTable
        columns={columns}
        data={partnerdata}
        component="partnerKyc"
        subMenu="Partner KYC approvel"
        pagiantionEntry={pagiantionEntry}
        paginationPageNumber={page}
      />

      <Pagination
        sx={{
          mt: "28px",
          "& .Mui-selected": {
            backgroundColor: "#f81b82 !important",
            color: "#fff"
          },
          "& .MuiPagination-ul": {
            justifyContent: "end"
          }
        }}
        component="div"
        count={Math.ceil(partnerFindSuccess?.totalCount / pagiantionEntry)}
        page={page}
        onChange={handleChangePage}
      />
    </>
  );
}

export default PartnerKycApproval;
